import React from 'react';
import HeroEn from '../components/HeroEn';
import StatsEn from '../components/StatsEn';
import ImageSliderEn from '../components/ImageSliderEn';

function HomeEn() {
  return (
    <>
      <HeroEn />
      <StatsEn />
      <ImageSliderEn />
    </>
  );
}

export default HomeEn;
